interface ChecklistIconProps {
  className?: string;
}

/** A ticked list, drawn to match HelpIcon (20px, 1.5 stroke, currentColor) beside it in the nav. */
export const ChecklistIcon = ({ className }: ChecklistIconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <path d="M3.5 5.5L4.75 6.75L7 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.5 11.5L4.75 12.75L7 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.5 5.75H16.5M9.5 11.75H16.5M9.5 16H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="5.25" cy="16" r="1.25" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
